import { render, staticRenderFns } from "./RoomNotifyList.vue?vue&type=template&id=492369b0"
import script from "./RoomNotifyList.vue?vue&type=script&lang=js"
export * from "./RoomNotifyList.vue?vue&type=script&lang=js"
import style0 from "./RoomNotifyList.vue?vue&type=style&index=0&id=492369b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports